import { useState } from "react"
import { CartProduct } from "../models/helpers/product"


export const useCart = () => {

    const [cartProducts, setCartProducts] = useState<CartProduct[]>([]);

    const addProductVariant = (product: CartProduct) => {
        const existingIndex = cartProducts.findIndex(p => p.selectedVariant.id === product.selectedVariant.id);
        if (existingIndex !== -1) {
            const updated = [...cartProducts];
            updated[existingIndex].quantity += product.quantity;
            setCartProducts(updated);
        }
        else {
            setCartProducts([...cartProducts, product]);
        }
    };

    const removeProductVariant = (variantId: string) => {
        setCartProducts(cartProducts.filter(p => p.selectedVariant.id !== variantId));
    };

    const changeProductVariantQuantity = (variantId: string, newQuantity: number) => {
        if (newQuantity <= 0) {
            removeProductVariant(variantId);
            return;
        }

        setCartProducts(cartProducts.map(p => {
            if (p.selectedVariant.id === variantId) {
                return { ...p, quantity: newQuantity };
            }
            return p;
        }));
    };

    const getProductVariantQuantity = (variantId: string): number => {
        return cartProducts.find(p => p.selectedVariant.id === variantId)?.quantity || 0;
    };

    const clearCart = () => {
        setCartProducts([]);
    };

    return {
        cartProducts,
        removeProductVariant,
        changeProductVariantQuantity,
        getProductVariantQuantity,
        addProductVariant,
        clearCart,
    };
}